import { Crosshair } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { CursorInfo } from './maplibre-viewer'

interface MapCoordHUDProps {
  cursor: CursorInfo | null
  className?: string
}

// Bottom-left HUD — cursor lat/lon + zoom. Glass surface, theme-adaptive.
// Sits above MapLibre's built-in scale-bar control without overlapping; on a
// phone it sits a step higher, clear of the attribution when that wraps onto
// two lines.
export function MapCoordHUD({ cursor, className }: MapCoordHUDProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute bottom-16 left-3 z-10 md:bottom-12',
        'inline-flex items-center gap-2 rounded-full border px-3 py-1',
        'border-border/40 bg-card/72 backdrop-blur-xl backdrop-saturate-150',
        'shadow-[0_10px_28px_-12px_hsl(var(--foreground)/0.25),inset_0_1px_0_hsl(0_0%_100%/0.08)]',
        'font-mono text-[10px] tabular-nums tracking-wider text-foreground',
        className
      )}
    >
      <Crosshair className="h-3 w-3 text-primary" />
      <span className="text-muted-foreground/80 uppercase tracking-[0.18em] text-[9px]">
        LAT/LON
      </span>
      <span className="text-foreground/90">
        {cursor ? `${cursor.lat.toFixed(5)}, ${cursor.lng.toFixed(5)}` : '— · —'}
      </span>
      <span className="mx-1 h-3 w-px bg-border/60" />
      <span className="text-muted-foreground/80 uppercase tracking-[0.18em] text-[9px]">Z</span>
      <span className="text-foreground/90">{cursor ? cursor.zoom.toFixed(1) : '—'}</span>
    </div>
  )
}
